'use client';

import { UserButton } from '@clerk/nextjs';
import ProjectsIcon from '@/components/icons/ProjectsIcon';
import React from 'react';
import OpportunitiesIcon from '@/components/icons/OpportunitiesIcon';

export default function MyUserButton() {
  return (
    <UserButton>
      <UserButton.MenuItems>
        <UserButton.Link
          label="Projects"
          labelIcon={<ProjectsIcon width={'16px'} height={'16px'} />}
          href="/dashboard/projects"
        />
        <UserButton.Link
          label="Opportunities"
          labelIcon={<OpportunitiesIcon width={'16px'} height={'16px'} />}
          href="/dashboard/opportunities"
        />
        {/* Default Manage account */}
        <UserButton.Action label="manageAccount" />
        <UserButton.Action label="signOut" />
      </UserButton.MenuItems>
    </UserButton>
  );
}
